export default __webpack_public_path__ + "static/media/female-icon2.3e242ce0.svg";